import { render, staticRenderFns } from "./YcoinExchangeCourseManage.vue?vue&type=template&id=b1a4f8a4&"
import script from "./YcoinExchangeCourseManage.vue?vue&type=script&lang=js&"
export * from "./YcoinExchangeCourseManage.vue?vue&type=script&lang=js&"
import style0 from "./YcoinExchangeCourseManage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YcoinExchangeCourseManage.vue?vue&type=style&index=1&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports